// import { useState } from "react";
// import { Button } from "./ui/button";
// import { Smile, AtSign, ImageIcon, ArrowUp } from "lucide-react";
// import { Input } from "antd";
// import { dentalIcons } from "../../dentail-indetifcation/utils-icons/dentalIcons";

// function clampToZoomRoot(pos, w, h, pad = 8) {
//   const zr = document.getElementById("zoom-root")?.getBoundingClientRect();
//   if (!zr || !pos) return { left: pos?.x || 0, top: pos?.y || 0 };
//   const minL = zr.left + pad;
//   const minT = zr.top + pad;
//   const maxL = zr.right - pad - (w || 0);
//   const maxT = zr.bottom - pad - (h || 0);
//   return {
//     left: Math.max(minL, Math.min(pos.x, maxL)),
//     top: Math.max(minT, Math.min(pos.y, maxT)),
//   };
// }
// export function CommentInput({ position, onSubmit, onCancel, isVisible }) {
//   const [text, setText] = useState("");

//   if (!isVisible) return null;
//   const size = { w: 200, h: 64 };
//   const { left, top } = clampToZoomRoot(position, size.w, size.h);

//   const handleSubmit = () => {
//     if (text.trim()) {
//       onSubmit(text.trim());
//       setText("");
//     }
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       handleSubmit();
//     }
//     if (e.key === "Escape") {
//       onCancel();
//     }
//   };

//   return (
//     <div
//       className="image_analysis_container absolute z-50"
//       style={{
//         left: left - 300,
//         top: top,
//       }}
//     >
//       <div
//         className="bg-white rounded-[12px] p-2 border border-[#EDF0F3] w-[300px] space-y-3"
//         style={{
//           boxShadow:
//             "0 4px 6px 0 rgba(14, 18, 27, 0.06), 0 2px 4px 0 rgba(14, 18, 27, 0.03)",
//         }}
//       >
//         <div
//           className="flex items-center justify-end cursor-pointer"
//           onClick={onCancel}
//         >
//           <img src={dentalIcons.closeIcon} alt="close" />
//         </div>
//         <Input.TextArea
//           value={text}
//           autoSize={{ minRows: 2, maxRows: 10 }}
//           onChange={(e) => setText(e.target.value)}
//           onKeyDown={handleKeyDown}
//           placeholder="Add a comment..."
//           className="placeholder-gray-400 mb-3 !rounded-[8px] text-[#C2C2C2] font-medium"
//           autoFocus
//         />

//         <div className="flex items-center justify-end">
//           <div className="flex items-center gap-2">
//             <Button
//               variant="ghost"
//               size="sm"
//               className="h-8 w-8 p-0 text-gray-400 hover:text-white hover:bg-gray-800"
//             >
//               <Smile className="w-4 h-4" />
//             </Button>
//           </div>

//           <Button
//             onClick={handleSubmit}
//             disabled={!text.trim()}
//             size="sm"
//             className="px-4 py-1 bg-[#20C3FF]  disabled:opacity-50"
//           >
//             Submit
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useState } from "react";
import { Button } from "./ui/button";
import { Smile, AtSign, ImageIcon, ArrowUp } from "lucide-react";
import { Input } from "antd";
import { dentalIcons } from "../../dentail-indetifcation/utils-icons/dentalIcons";

// --- NEW: compute a "safe" rect = zoom-root minus occluders ---
function computeSafeRect(pad = 8) {
  const zr = document.getElementById("zoom-root")?.getBoundingClientRect();
  if (!zr) return null;

  // Identify common occluders (change selectors if yours differ)
  const bottomToolbar =
    document.querySelector("[data-bottom-toolbar]")?.getBoundingClientRect() ||
    document.querySelector(".bottom-toolbar")?.getBoundingClientRect() ||
    null;

  const rightPanel =
    document.querySelector("[data-comments-panel]")?.getBoundingClientRect() ||
    document.querySelector(".comments-panel")?.getBoundingClientRect() ||
    null;

  // Start with zoom-root
  let left = zr.left + pad;
  let top = zr.top + pad;
  let right = zr.right - pad;
  let bottom = zr.bottom - pad;

  // Shrink right edge if comments panel is docked on the right
  if (rightPanel) {
    // only shrink if panel actually overlaps horizontally with zoom-root
    if (rightPanel.left < right && rightPanel.left > left) {
      right = Math.min(right, rightPanel.left - pad);
    }
  }

  // Shrink bottom edge if bottom toolbar is floating at the bottom
  if (bottomToolbar) {
    // only shrink if toolbar actually overlaps vertically with zoom-root
    if (bottomToolbar.top < bottom && bottomToolbar.top > top) {
      bottom = Math.min(bottom, bottomToolbar.top - pad);
    }
  }

  // Also respect the viewport (safety, just in case)
  const vw = document.documentElement.clientWidth;
  const vh = document.documentElement.clientHeight;
  left = Math.max(left, 0 + pad);
  top = Math.max(top, 0 + pad);
  right = Math.min(right, vw - pad);
  bottom = Math.min(bottom, vh - pad);

  return {
    left,
    top,
    right,
    bottom,
    width: right - left,
    height: bottom - top,
  };
}

function placePopover(anchor, w, h, pad = 8) {
  const safe = computeSafeRect(pad);
  if (!safe || !anchor) return { left: anchor?.x || 0, top: anchor?.y || 0 };

  // First attempt: to the right & above a bit
  let left = anchor.x + 12;
  let top = anchor.y - 12;

  // If overflows right -> flip to left
  if (left + w > safe.right) left = anchor.x - w - 12;
  // If now overflows left -> clamp
  if (left < safe.left) left = safe.left;

  // If overflows bottom -> flip above
  if (top + h > safe.bottom) top = anchor.y - h - 12;
  // If still overflows top -> clamp
  if (top < safe.top) top = safe.top;

  // Final clamp
  left = Math.max(safe.left, Math.min(left, safe.right - w));
  top = Math.max(safe.top, Math.min(top, safe.bottom - h));

  return { left, top };
}

export function CommentInput({ position, onSubmit, onCancel, isVisible }) {
  const [text, setText] = useState("");
  if (!isVisible) return null;

  // match your actual box size (width + approximate height)
  const SIZE = { w: 300, h: 160 };
  const { left, top } = placePopover(position, SIZE.w, SIZE.h);

  return (
    <div
      className="fixed z-[1000]" // ensure above canvases and toolbars
      style={{ left, top }}
    >
      <div
        className="bg-white rounded-[12px] p-2 border border-[#EDF0F3] w-[300px] space-y-3"
        style={{
          boxShadow:
            "0 4px 6px rgba(14,18,27,.06), 0 2px 4px rgba(14,18,27,.03)",
        }}
      >
        <div
          className="flex items-center justify-end cursor-pointer"
          onClick={onCancel}
        >
          <img src={dentalIcons.closeIcon} alt="close" />
        </div>

        <Input.TextArea
          value={text}
          autoSize={{ minRows: 2, maxRows: 6 }}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              const v = text.trim();
              if (v) {
                onSubmit(v);
                setText("");
              }
            }
            if (e.key === "Escape") onCancel();
          }}
          placeholder="Add a comment..."
          className="placeholder-gray-400 mb-3 !rounded-[8px] text-[#333]"
          autoFocus
        />

        <div className="flex items-center justify-end">
          <Button
            onClick={() => {
              const v = text.trim();
              if (v) {
                onSubmit(v);
                setText("");
              }
            }}
            disabled={!text.trim()}
            size="small"
            className="px-4 py-1 bg-[#20C3FF] text-white disabled:opacity-50"
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
}
